import { render, staticRenderFns } from "./ImpersonateButton.vue?vue&type=template&id=6dbb0514&"
import script from "./ImpersonateButton.vue?vue&type=script&lang=js&"
export * from "./ImpersonateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports